module.exports = __webpack_public_path__ + "static/img/table_arrow.fb686d3c.svg";